import React, {useMemo, useContext} from 'react';
import PropTypes from 'prop-types';
import {Tooltip} from '@mui/material';
import {makeStyles} from '@mui/styles'
import helpIcon from '../../../assets/images/help_normal.png';
import {hasValue} from '../../../utils/utils';
import LayoutContext from '../../Layouts/LayoutContext';

function SMCLabel({
    text,
    tooltip,
    disabled,
    style,
    bold,
    fontSize,
    useContextWidth,
    children,
    className,
    width,
    onClick,
    inline,
    ...rest
}) {
    const layoutContext = useContext(LayoutContext);
    const classes = useStyles({disabled, bold, fontSize});

    const _width = useMemo(() => {
        if (hasValue(width)) {
            return width;
        }
        else if (useContextWidth && layoutContext && hasValue(layoutContext.labelWidth)) {
            return layoutContext.labelWidth;
        }
        return undefined;
    }, [width, useContextWidth, layoutContext]);
    
    // Don't do onClick action if disabled
    const onClickAction = disabled ? undefined : onClick;

    return (
        <div className={classes.labelText} style={{ width: _width, display: inline ? 'inline-block' : 'block'}} {...rest}>
            <span className={className} onClick={onClickAction} style={style}>
                {text || children}
            </span>
            {
                tooltip &&
                <Tooltip title={tooltip} placement="right" classes={{ tooltip: classes.labelTooltip }}>
                    <img src={helpIcon} alt="" className={classes.tooltipImg} />
                </Tooltip>
            }
        </div>
    );
};


const useStyles = makeStyles({
    labelTooltip: {
        maxWidth: '200px',
        whiteSpace: 'pre-line',
        textAlign: 'start'
    },
    labelText: props => ({
        // opacity: props.disabled ? '0.6' : '1',
        fontWeight: props.bold ? 'bold' : 'inherit',
        fontSize: props.fontSize,
        display: 'inline-block',
        textAlign: 'start'
    }),
    tooltipImg: props => ({
        // opacity: props.disabled ? '0.6' : '0.8',
        height: '9px',
        paddingLeft: '2px',
        verticalAlign: 'top'
    })
});

SMCLabel.propTypes = {
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    tooltip: PropTypes.node,
    disabled: PropTypes.bool,
    style: PropTypes.object,
    bold: PropTypes.bool,
    className: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

// SMCLabel.whyDidYouRender = true;

export default React.memo(SMCLabel);